const Line = (state = {
  hasApnFilter: '',
}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default Line;



// WEBPACK FOOTER //
// ./src/reducers/LineReducer.js